module.exports = {
    parse: require('./lib/parse'),
    stringify: require('./lib/stringify')
};



//////////////////
// WEBPACK FOOTER
// ./~/html-parse-stringify2/index.js
// module id = 456
// module chunks = 0